// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"55c98be0","292":"8fb28324","406":"2e0955c4","642":"25f2e41e","696":"4f010997"}[chunkId] + ".chunk.js";
};